var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-clock") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-clock",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Bounds",
    fillOpacity: 0,
    fill: "#FFFFFF",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,27 C18.3846269,27 18.7016304,27.2895301 18.7449542,27.6625342 L18.75,27.75 L18.75,30.75 C18.75,31.1642136 18.4142136,31.5 18,31.5 C17.6153731,31.5 17.2983696,31.2104699 17.2550458,30.8374658 L17.25,30.75 L17.25,27.75 C17.25,27.3357864 17.5857864,27 18,27 Z",
    id: "Stroke-1",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18,4.5 C18.3846269,4.5 18.7016304,4.78953014 18.7449542,5.16253416 L18.75,5.25 L18.75,8.25 C18.75,8.66421356 18.4142136,9 18,9 C17.6153731,9 17.2983696,8.71046986 17.2550458,8.33746584 L17.25,8.25 L17.25,5.25 C17.25,4.83578644 17.5857864,4.5 18,4.5 Z",
    id: "Stroke-2",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.25,17.25 C8.66421356,17.25 9,17.5857864 9,18 C9,18.3846269 8.71046986,18.7016304 8.33746584,18.7449542 L8.25,18.75 L5.25,18.75 C4.83578644,18.75 4.5,18.4142136 4.5,18 C4.5,17.6153731 4.78953014,17.2983696 5.16253416,17.2550458 L5.25,17.25 L8.25,17.25 Z",
    id: "Stroke-3",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.75,17.25 C31.1642136,17.25 31.5,17.5857864 31.5,18 C31.5,18.3846269 31.2104699,18.7016304 30.8374658,18.7449542 L30.75,18.75 L27.75,18.75 C27.3357864,18.75 27,18.4142136 27,18 C27,17.6153731 27.2895301,17.2983696 27.6625342,17.2550458 L27.75,17.25 L30.75,17.25 Z",
    id: "Stroke-4",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(1.500000, 1.427250)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5006,0.072375 C7.38797614,0.072375 0.0006,7.46006196 0.0006,16.5727509 C0.0006,25.6853075 7.38784384,33.072375 16.5006,33.072375 C25.6133561,33.072375 33.0006,25.6853074 33.0006,16.5727509 C33.0006,7.46006198 25.6132238,0.072375 16.5006,0.072375 Z M16.5006,1.572375 C24.7847826,1.572375 31.5006,8.28847497 31.5006,16.5727509 C31.5006,24.8568723 24.784937,31.572375 16.5006,31.572375 C8.21626295,31.572375 1.5006,24.8568723 1.5006,16.5727509 C1.5006,8.28847496 8.2164174,1.572375 16.5006,1.572375 Z",
    id: "Stroke-5",
    fill: "#323232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6112563,4.92967693 C22.8283445,4.57690851 23.2903046,4.466918 23.6430731,4.68400626 C23.9706437,4.88558822 24.0888804,5.29830969 23.9302871,5.63868757 L23.8887437,5.71582307 L17.8887437,15.4658231 C17.6716555,15.8185915 17.2096954,15.928582 16.8569269,15.7114937 C16.5293563,15.5099118 16.4111196,15.0971903 16.5697129,14.7568124 L16.6112563,14.6796769 L22.6112563,4.92967693 Z",
    id: "Stroke-7",
    fill: "#E40000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.09881764,12.4506458 C9.28964601,12.1166961 9.69830635,11.9851072 10.0436592,12.1325534 L10.1221042,12.1715676 L15.3721042,15.1715676 C15.7317423,15.3770751 15.8566898,15.8352161 15.6511824,16.1948542 C15.460354,16.5288039 15.0516936,16.6603928 14.7063408,16.5129466 L14.6278958,16.4739324 L9.3778958,13.4739324 C9.01825771,13.2684249 8.89331017,12.8102839 9.09881764,12.4506458 Z",
    id: "Stroke-9",
    fill: "#E40000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5,18.82275 C15.2595,18.82275 14.25,17.81325 14.25,16.57275 C14.25,15.33225 15.2595,14.32275 16.5,14.32275 C17.7405,14.32275 18.75,15.33225 18.75,16.57275 C18.75,17.81325 17.7405,18.82275 16.5,18.82275",
    id: "Fill-11",
    fill: "#E40000"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClock);
export default __webpack_public_path__ + "static/media/icon-clock.ff1710f249f8486335fb6d02b056988f.svg";
export { ForwardRef as ReactComponent };